/** Расширения, которые точно являются звуком, а не документом. */
const AUDIO = /\.(webm|mp4|m4a|mp3|ogg|oga|wav|aac)(\?|#|$)/i;

/**
 * Похоже ли вложение на голосовую запись — по имени файла или по ссылке.
 *
 * ⚠️ Проигрывателя здесь больше нет (10.09.2026): запись играет общий плеер
 * `components/ui/AudioPlayer.tsx`, он же досчитывает длину записи с микрофона.
 * Два плеера с разным поведением — это ровно то, от чего уходили.
 */
export function isAudioFile(nameOrUrl: string): boolean {
  return AUDIO.test(nameOrUrl);
}
